export const isObjectEmpty = <T extends Record<string, unknown>>(obj: T, ignore?: (keyof T)[]) => {
  for (const prop in obj) {
    if (!ignore?.includes(prop)) {
      const value = obj[prop];
      if (value && Array.isArray(value) && value.length > 0) {
        return false;
      }
      if (value && typeof value === "object" && Object.keys(value as Record<string, unknown>).length > 0) {
        return false;
      }
      if (value && typeof value !== "object" && !Array.isArray(value)) {
        return false;
      }
    }
  }
  return true;
};
